export const GET = {
  REQUEST: 'Orders/Get/Request',
  SUCCESS: 'Orders/Get/Success',
  FAILURE: 'Orders/Get/Failure'
};
export const CLEAR = {
  SUCCESS: 'Orders/Clear/Success'
};
export const CREATE = {
  REQUEST: 'Orders/Create/Request',
  SUCCESS: 'Orders/Create/Success',
  FAILURE: 'Orders/Create/Failure'
};
export const UPDATE = {
  REQUEST: 'Orders/Update/Request',
  SUCCESS: 'Orders/Update/Success',
  FAILURE: 'Orders/Update/Failure'
};

export const DELETE = {
  REQUEST: 'Orders/Delete/Request',
  SUCCESS: 'Orders/Delete/Success',
  FAILURE: 'Orders/Delete/Failure'
};
export const SEND = {
  REQUEST: 'Orders/Send/Request',
  SUCCESS: 'Orders/Send/Success',
  FAILURE: 'Orders/Send/Failure'
};
export const CANCEL = {
  REQUEST: 'Orders/Cancel/Request',
  SUCCESS: 'Orders/Cancel/Success',
  FAILURE: 'Orders/Cancel/Failure'
};
export const DELETE_ASSIGNMENT = {
  REQUEST: 'Orders/DeleteAssignment/Request',
  SUCCESS: 'Orders/DeleteAssignment/Success',
  FAILURE: 'Orders/DeleteAssignment/Failure'
};
export const DOWNLOAD = {
  REQUEST: 'Orders/Download/Request',
  SUCCESS: 'Orders/Download/Success',
  FAILURE: 'Orders/Download/Failure'
};
export const CONFIRM_DELIVERY_FOR_SUBMIT = {
  REQUEST: 'Orders/ConfirmDeliveryForSubmit/Request',
  SUCCESS: 'Orders/ConfirmDeliveryForSubmit/Success',
  FAILURE: 'Orders/ConfirmDeliveryForSubmit/Failure'
};
export const CONFIRM_DELIVERY = {
  REQUEST: 'Orders/ConfirmDelivery/Request',
  SUCCESS: 'Orders/ConfirmDelivery/Success',
  FAILURE: 'Orders/ConfirmDelivery/Failure'
};
export const CAN_UPDATE = {
  REQUEST: 'Orders/CanUpdate/Request',
  SUCCESS: 'Orders/CanUpdate/Success',
  FAILURE: 'Orders/CanUpdate/Failure'
};
export const CAN_REMOVE_SERVICE_REQUEST = {
  REQUEST: 'Orders/CanRemoveServiceRequest/Request',
  SUCCESS: 'Orders/CanRemoveServiceRequest/Success',
  FAILURE: 'Orders/CanRemoveServiceRequest/Failure'
};
